import type { Row } from '@tanstack/react-table';
import type React from 'react';
import ListViewAssetRow from './ListViewAssetRow';
import ListViewCollectionRow from './ListViewCollectionRow';
import type { DensityConfig, HighlightTerms, ListViewRow as ListViewRowType } from './listView.types';

interface ListViewRowProps {
  row: Row<ListViewRowType>;
  index: number;
  classes: Record<string, string>;
  density: DensityConfig;
  highlightTerms: HighlightTerms;
}

const ListViewRow: React.FC<ListViewRowProps> = ({ row, index, classes, density, highlightTerms }) => {
  const original = row.original;

  if (original.__rowType === 'collection') {
    return (
      <ListViewCollectionRow
        row={row}
        collection={original}
        index={index}
        classes={classes}
        density={density}
        highlightTerms={highlightTerms}
      />
    );
  }

  return (
    <ListViewAssetRow
      row={row}
      asset={original}
      index={index}
      classes={classes}
      density={density}
      highlightTerms={highlightTerms}
    />
  );
};

export default ListViewRow;
